/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestResultState } from './AutoTestResultState';
const AutoTestResultParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['createdAt', parsers.moment, 'created_at'],
    ['updatedAt', parsers.moment, 'updated_at'],
    ['startedAt', /* #__PURE__ */ parsers.maybeNull(parsers.moment), 'started_at'],
    ['workId', codecNumber, 'work_id'],
    ['state', AutoTestResultState],
    ['pointsAchieved', codecNumber, 'points_achieved'],
]));
export class AutoTestResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestResultParser.decode(input).map(res => new AutoTestResult(res));
    }
    static unsafeDecode(input) {
        return AutoTestResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestResultParser.encode(data);
    }
    static schema() {
        return AutoTestResultParser.schema();
    }
}
